import { useRouter } from "next/router";
import { Button } from "./ui/button";
import { Lock } from "@phosphor-icons/react";
import { useAtom } from "jotai";
import { purchasePopup, loginPopup } from "@/Atoms";

function LockedContent({ title, description, isLogin, label, blur = true }) {
  const router = useRouter();
  const currentPath = router.asPath;
  const [openPurchasePopup, setOpenPurchasePopup] = useAtom(purchasePopup);
  const [openLoginPopup, setOpenLoginPopup] = useAtom(loginPopup);

  function toLogin() {
    setOpenLoginPopup(true);
  }

  function toPricing() {
    router.push(`/pricing`);
  }

  return (
    <div
      className={`flex flex-col items-center justify-center h-full p-4 ${
        blur ? "lg:bg-background/80 backdrop-blur-sm" : ""
      }`}
    >
      {label && <p>{label}</p>}
      <Lock className='flex-shrink-0 mx-auto mt-0 mb-2 text-3xl lg:text-2xl' />
      <p className='mb-1.5 text-xl lg:text-lg font-bold text-white mt-0'>
        {isLogin ? (
          <>{title ? title : "Subscribe to Continue"}</>
        ) : (
          "Content Locked"
        )}
      </p>
      <p className='max-w-sm mx-auto my-0 text-sm leading-snug text-center lg:text-xs text-white/50'>
        {isLogin ? (
          <>
            {description
              ? description
              : "To access this content, please subscribe and enjoy exclusive benefits available only to our subscribers."}
          </>
        ) : (
          "Login or Register a FREE account to continue browsing our content"
        )}
      </p>
      <div className='flex items-center justify-center gap-3 mt-4'>
        {!isLogin ? (
          <Button
            onClick={toLogin}
            className='!h-auto lg:px-3.5 font-medium lg:py-1.5 text-sm lg:text-xs'
          >
            Login to Continue
          </Button>
        ) : (
          <Button
            onClick={toPricing}
            className='h-auto px-3.5 font-medium py-1.5 text-xs'
          >
            Upgrade Plan
          </Button>
        )}
      </div>
    </div>
  );
}

export default LockedContent;
